export default {
    toolbar: {},
    toolbarLandscape: {},
};
